<template>
  <v-container class="cmpbk black--text" id="reg-container">
    <h2 class="white--text">Participant Registration</h2>
<!-- <v-btn small color="orange" @click="fillDev">
  Dev Fill
</v-btn> -->
    <v-stepper v-model="stepcount" non-linear vertical class="py-2">
      <v-stepper-step :complete="stepcount > 1" step="1">
        Participation
        <small>How will you participate?</small>
      </v-stepper-step>

      <v-stepper-content step="1" class="ml-4 my-0 mr-2 pa-0">
        <v-card color="whitesmoke" class="mb-4 pa-4" height="auto">
          <v-row>
            <v-col cols="12">
              <v-select
                attach
                v-model="form.participationType"
                :items="participationItems"
                label="Are you participating in person or virtually?*"
                :rules="reqRules"
              ></v-select>
            </v-col>
          </v-row>
        </v-card>

        <v-btn color="primary" @click="update(2)">Continue</v-btn>
        <v-btn text @click="cancel">Cancel</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepcount > 2" step="2">
        Contact Information
      </v-stepper-step>

      <v-stepper-content step="2" class="ml-4 my-0 mr-2 pa-0">
        <v-card color="whitesmoke" class="mb-4 pa-4" height="auto">
          <v-form ref="contactForm" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.name"
                  label="Name*"
                  maxlength="120"
                  :rules="nameRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.email"
                  label="Email*"
                  maxlength="120"
                  placeholder="myname@domain.com"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="form.address"
                  label="Address*"
                  maxlength="150"
                  :rules="reqRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.city"
                  label="City*"
                  maxlength="80"
                  :rules="reqRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.state"
                  label="State*"
                  maxlength="2"
                  :rules="reqRules"
                  hint="exmp. CA"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.zip"
                  label="Zip*"
                  maxlength="10"
                  :rules="reqRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.phone"
                  label="Phone Number*"
                  maxlength="15"
                  placeholder="123-123-1234"
                  v-mask="'###-###-####'"
                  :rules="phoneRules"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card>

        <v-btn color="primary" @click="update(3)">Continue</v-btn>
        <v-btn color="primary" class="ml-2" @click="stepcount = 1">Go Back</v-btn>
        <v-btn text @click="cancel">Cancel</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepcount > 3" step="3">
        Event Information
      </v-stepper-step>

      <v-stepper-content step="3" class="ml-4 my-0 mr-2 pa-0">
        <v-card color="whitesmoke" class="mb-4 pa-4 step-3-card" height="auto">
          <v-row>
            <v-col cols="12">
              <v-select
                attach
                v-model="form.hear"
                :items="hearItems"
                label="How did you hear about our event?*"
                :rules="reqRules"
              ></v-select>
            </v-col>

            <v-col cols="12" v-if="form.hear === 'Other'">
              <v-text-field
                v-model="form.hearOther"
                label="Other - please tell us how you heard about the event*"
                maxlength="120"
                :rules="otherHearRules"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                attach
                v-model="form.distance"
                :items="distanceItems"
                label="Intended distance?*"
                :rules="reqRules"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                attach
                v-model="form.mode"
                :items="modeItems"
                label="Intended mode?*"
                :rules="reqRules"
              ></v-select>
            </v-col>
          </v-row>

          <div class="step-3-spacer"></div>
        </v-card>

        <v-btn color="primary" @click="update(4)">Continue</v-btn>
        <v-btn color="primary" class="ml-2" @click="stepcount = 2">Go Back</v-btn>
        <v-btn text @click="cancel">Cancel</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepcount > 4" step="4">
        Donation Selection
      </v-stepper-step>

      <v-stepper-content step="4" class="ml-4 my-0 mr-2 pa-0">
        <v-card color="whitesmoke" class="mb-4 pa-4" height="auto">
          <div class="mb-3">
            Registration is a <strong>$20 donation</strong>. We also offer a
            <strong>$65 Registration Package</strong> that includes registration,
            a shirt, and a special 13 Souls Run medal.
          </div>

          <v-radio-group v-model="form.donationLevel">
            <v-radio
              label="$20 Registration Donation only"
              value="20_only"
            ></v-radio>

            <v-radio
              label="$65 Registration Package"
              value="65_package"
            ></v-radio>

            <v-radio
              label="I'd like the Package but would like to make a larger donation"
              value="package_plus"
            ></v-radio>
          </v-radio-group>
        </v-card>

        <v-btn color="primary" @click="continueFromDonation">Continue</v-btn>
        <v-btn color="primary" class="ml-2" @click="stepcount = 3">Go Back</v-btn>
        <v-btn text @click="cancel">Cancel</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepcount > 5" step="5">
        Package Details
      </v-stepper-step>

      <v-stepper-content step="5" class="ml-4 my-0 mr-2 pa-0">
        <v-card color="whitesmoke" class="mb-4 pa-4" height="auto">
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                attach
                v-model="form.shirtType"
                :items="shirtTypeItems"
                label="Shirt type?*"
                :rules="packageRules"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                attach
                v-model="form.shirtSize"
                :items="shirtSizeItems"
                label="Size?*"
                :rules="packageRules"
              ></v-select>
            </v-col>
          </v-row>
        </v-card>

        <v-container fluid class="px-0">
          <h4>To continue you must agree to the waiver below:</h4>
          <a
            href="/13_SOULS_RUN_RELEASE_AND_WAIVER_OF_LIABILITY_AGREEMENT_2026.pdf"
            target="_blank"
          >
            Read Waiver Here
          </a>

          <v-checkbox
            v-model="showFinish"
            label="I have read, understood, and agree to the 13 SOULS RUN RELEASE AND WAIVER OF LIABILITY."
          ></v-checkbox>
        </v-container>

        <div v-if="showFinish">
          <h3>Complete Registration</h3>

          <div v-if="form.donationLevel === '65_package'">
            <h4 class="mt-3">
              Package Donation includes registration, a shirt, and a medal: $65
            </h4>
            <v-btn color="primary" @click="checkoutPackage65" class="mb-2">
              Donate now with PayPal: $65
            </v-btn>
          </div>

          <div v-if="form.donationLevel === 'package_plus'">
            <h4 class="mt-3">
              Package plus an additional donation
            </h4>
            <v-btn color="primary" @click="checkoutPackagePlus" class="mb-2">
              Set your own value (package + extra donation)
            </v-btn>
          </div>

          <div class="mt-3">
            <v-btn color="primary" class="ml-2" @click="stepcount = 4">
              Go Back
            </v-btn>
            <v-btn text class="mb-2" @click="cancel">Cancel</v-btn>
          </div>
        </div>
      </v-stepper-content>
    </v-stepper>

    <!-- Checkout dialogs -->
    <v-dialog
      v-model="showCheckout1"
      fullscreen
      eager
      transition="dialog-bottom-transition"
     style="background-color: #2b2b2b;"
    >
      <v-card class="fill-height"     style="background-color: #2b2b2b;">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeCheckout1">
            <v-icon>$close</v-icon>
          </v-btn>
          <v-toolbar-title>Checkout</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <checkout @paypal_done="paypal_done"
         v-if="showCheckout1"
        @close="closeCheckout1" />


      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showCheckout2"
      fullscreen
     eager
      transition="dialog-bottom-transition"
     
    >
      <v-card class="fill-height "  style="background-color: #2b2b2b;">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeCheckout2">
            <v-icon>$close</v-icon>
          </v-btn>
          <v-toolbar-title>Checkout</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <checkout2 @paypal_done="paypal_done" 
         v-if="showCheckout2"
        @close="closeCheckout2" />


      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showCheckout3"
      fullscreen
      eager
      transition="dialog-bottom-transition"
    
    >
      <v-card class="fill-height"  style="background-color: #2b2b2b;">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeCheckout3">
            <v-icon>$close</v-icon>
          </v-btn>
          <v-toolbar-title>Checkout</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <checkout3
         v-if="showCheckout3"
        @paypal_done="paypal_done"
         @close="closeCheckout3" />


      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import checkout from "./checkout.vue";
import checkout2 from "./checkout2.vue";
import checkout3 from "./checkout3.vue";

export default {
  name: "participant_register",
  mixins: [bus_common],
  components: {
    checkout,
    checkout2,
    checkout3,
  },
  data() {
    return {
      valid: true,
      stepcount: 1,
      showFinish: false,

      showCheckout1: false,
      showCheckout2: false,
      showCheckout3: false,

      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      reqRules: [
        (v) => !!v || "This field is required",
      ],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 120) || "Name must be less than 120 characters",
      ],
      phoneRules: [
        (v) => !!v || "Phone is required",
        (v) =>
          /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(v) ||
          "Phone must be valid",
      ],

      participationItems: ["In Person", "Virtually"],
      hearItems: [
        "Yard Sign",
        "Newspaper",
        "Word of Mouth",
        "Banner",
        "Family/Friend",
        "Flyer",
        "Past Participant Email",
        "Social Media",
        "Other",
      ],
      distanceItems: ["1K", "5K", "10K", "Half Marathon"],
      modeItems: ["Run", "Walk", "Bike"],
      shirtTypeItems: ["Men's Crew Neck", "Women's V-neck"],
      shirtSizeItems: ["XS", "S", "M", "L", "XL", "2X", "3X", "4X"],

      form: {
        regstId: 0,
        participationType: "",
        name: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        email: "",
        phone: "",
        hear: "",
        hearOther: "",
        distance: "",
        mode: "",
        donationLevel: "",
        shirtType: "",
        shirtSize: "",
        amount: 0.0,
      },
      form_dev: {
        regstId: 0,
        participationType: "In Person",
        name: "John Molt",
        address: "123 Main St",
        city: "Reno",
        state: "NV",
        zip: "89501",
        email: "jvonmolt@gmail.com",
        phone: "111-111-1111",
        hear: "Social Media",
        hearOther: "",
        distance: "5K",
        mode: "Run",
        donationLevel: "20_only",
        shirtType: "Men's Crew Neck",
        shirtSize: "L",
        amount: 20.0,
      },
    };
  },
  computed: {
    otherHearRules() {
      if (this.form.hear === "Other") {
        return [(v) => !!v || "Please tell us how you heard about the event"];
      }
      return [];
    },
    packageRules() {
      if (this.requiresPackagePage) {
        return [(v) => !!v || "This field is required"];
      }
      return [];
    },
    requiresPackagePage() {
      return (
        this.form.donationLevel === "65_package" ||
        this.form.donationLevel === "package_plus"
      );
    },
  },
  methods: {
    fillDev() {
      
        const id = this.form.regstId;

        this.form = this.mno(this.form_dev);
        this.form.regstId = id;
    },
    cancel() {
      this.$router.push("/");
    },

    closeCheckout1() {
      this.showCheckout1 = false;
    },
    closeCheckout2() {
      this.showCheckout2 = false;
    },
    closeCheckout3() {
      this.showCheckout3 = false;
    },

    get_record() {
      let regstId = this.$store.state.regstId;
      var formIn = {
        regstId: regstId,
        apiname: "get_record",
      };

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.stepcount = 1;
          this.form = this.mno(data);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    persistAndContinue(nextStep) {
      var formIn = {};
      formIn.fields = this.form;
      formIn.apiname = "update_record_part";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.form = this.mno(data);
          this.stepcount = nextStep;
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    update(count) {
      if (count === 3) {
        let valid = this.$refs.contactForm.validate();
        if (!valid) {
          this.swall_it(
            "Form Entry Status",
            "Please address the required fields before continuing.",
            "error",
            null,
            null
          );
          return;
        }
      }

      if (count === 4) {
        if (!this.form.hear || !this.form.distance || !this.form.mode) {
          this.swall_it(
            "Form Entry Status",
            "Please complete the event information before continuing.",
            "error",
            null,
            null
          );
          return;
        }

        if (this.form.hear === "Other" && !this.form.hearOther) {
          this.swall_it(
            "Form Entry Status",
            "Please tell us how you heard about the event.",
            "error",
            null,
            null
          );
          return;
        }
      }

      this.persistAndContinue(count);
    },

    continueFromDonation() {
      if (!this.form.donationLevel) {
        this.swall_it(
          "Donation Selection",
          "Please choose a donation option before continuing.",
          "error",
          null,
          null
        );
        return;
      }

      if (this.form.donationLevel === "20_only") {
        this.checkout20Only();
        return;
      }

      this.persistAndContinue(5);
    },

    create_min_record() {
      var formIn = {};
      formIn.fields = this.form;
      formIn.apiname = "create_min_record_part";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.form = this.mno(data);
          this.$store.commit("setRegstId", this.form.regstId);
          this.swall_it(
            "Registration Status",
            "Starting new registration",
            "success",
            null,
            null
          );
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    checkout20Only() {
      var formIn = {};
      formIn.fields = this.form;
      formIn.apiname = "update_record_part";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.form = this.mno(data);
          this.showCheckout1 = true;
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    checkoutPackage65() {
      if (!this.form.shirtType || !this.form.shirtSize) {
        this.swall_it(
          "Package Details",
          "Please choose a shirt type and size before continuing.",
          "error",
          null,
          null
        );
        return;
      }

      var formIn = {};
      formIn.fields = this.form;
      formIn.apiname = "update_record_part";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.form = this.mno(data);
          this.showCheckout2 = true;
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    checkoutPackagePlus() {
      if (!this.form.shirtType || !this.form.shirtSize) {
        this.swall_it(
          "Package Details",
          "Please choose a shirt type and size before continuing.",
          "error",
          null,
          null
        );
        return;
      }

      var formIn = {};
      formIn.fields = this.form;
      formIn.apiname = "update_record_part";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.form = this.mno(data);
          this.showCheckout3 = true;
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    init() {
      this.show_loader(false);
      if (this.$store.state.regstId == -1) {
        this.create_min_record();
      } else {
        this.get_record();
      }
      
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/site.scss";

@media (min-width: 0px) {
  #reg-container {
    max-width: 768px;
  }

  .step-3-card {
    min-height: 320px;
  }

  .step-3-spacer {
    height: 140px;
  }
}
</style>